import React, {FC, Fragment, isValidElement} from 'react';
import css from './breadcrumbs.module.scss';
import {castArray, nonNullable} from 'helpers';

export const Breadcrumbs: FC<{className?: string}> = ({className = '', children}) => (
  <nav className={css('breadcrumbs', className)}>
    {castArray(children).filter(nonNullable).map((item, index) =>
      <Fragment key={index}>
        {index !== 0 &&
          <div className={css.separator}>/</div>
        }
        <div className={css('item', isValidElement(item) ? item.props?.className : '')} key={index}>
          {item}
        </div>
      </Fragment>
    )}
  </nav>
);
